module.exports = __webpack_public_path__ + "static/media/0025_IMG_LES_ENSEIGNES_LE_POISSONNIER_SCRABBLE.2c0e0209.png";